var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M47.383,44.558,35.461,32.636a20.005,20.005,0,1,0-2.824,2.824L44.558,47.383a2,2,0,1,0,2.824-2.824ZM20.005,35.984A15.979,15.979,0,1,1,35.984,20.005,15.979,15.979,0,0,1,20.005,35.984Z",
    transform: "translate(0.032 0.032)",
    fill: "#38d2d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.379a6ae2d95f7bc7aeefdd06c0783aaa.svg";
export { ForwardRef as ReactComponent };